import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-switch',
  templateUrl: './app-switch.component.html',
  styleUrls: ['./app-switch.component.scss']
})
export class AppSwitchComponent implements OnInit {

  @Input() model: any;
  @Input() disabled: boolean;
  @Output() notify: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
    // console.log(this.disabled);
  }

  onChange() {
    this.notify.emit(this.model);
  }


}
